import { STOCK_OPNAME } from "../../constants/admin/masterdata/constants";

const initialState = {
  data: [],
  count: 0,
  loading: true,
  error: null,
};

const stockOpnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case STOCK_OPNAME.LOADING_DATA_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        loading: action.load,
      };

    case STOCK_OPNAME.GET_DATA_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        data: action.data?.data || [],
        count: action.data?.count || 0,
        loading: false,
        error: null,
      };

    case STOCK_OPNAME.SET_STOCK_OPNAME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case STOCK_OPNAME.CLEAR_STOCK_OPNAME_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default stockOpnameReducer;
